import { useQuery } from '@tanstack/react-query';
/* eslint-disable-next-line no-restricted-imports */
import * as t from 'io-ts';

import { fetchWithDecode } from '@jane/business-admin/util';
import { janeApiV2 } from '@jane/shared/data-access';

const tTag = t.type({
  id: t.number,
  value: t.string,
  tag_type: t.string,
});
const t_TagResponse = t.type({ tags: t.array(tTag) });
export type Tag = t.TypeOf<typeof tTag>;
type TagResponse = t.TypeOf<typeof t_TagResponse>;

const fetchTags = async (): Promise<TagResponse> => {
  const url = `/business/tags`;
  const tPayload = t.type({
    tags: t.array(tTag),
  });
  const data = await fetchWithDecode(
    janeApiV2.get<TagResponse>(url),
    tPayload,
    url
  );

  return data;
};

export const useTags = () => {
  return useQuery<TagResponse>({
    queryFn: () => fetchTags(),
    queryKey: ['tags'],
    staleTime: Infinity,
    useErrorBoundary: true,
  });
};
